<template>
    <div class="maintainIndex spackage padding-20 bgc box-shadow">

        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <div class="block">
                <p class="name">基本设置</p>

                <el-form-item label="星球名称" prop="starname">
                    <el-input class="min" v-model="form.starname" placeholder="输入星球名称，不超过10个字" maxlength="10" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="星球封面" prop="starlogourl">
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                        <!--<el-button @setImage="setCoverfile">选择文件</el-button>-->
                        <!--<el-button>素材库</el-button>-->
                        <!--<p>建议尺寸750*455px的JPG、PNG格式， 图片小于2M。</p>-->
                    </div>
                    <div class="position">
                        <el-button>选择文件</el-button>
                        <el-button type="warning" @click="dialogVisible = true">素材库</el-button>
                        <p>建议上传尺寸750*445，jpg或png格式，不超过2M</p>
                    </div>

                </el-form-item>

                <el-form-item label="星球标签" prop="tagcode">
                    <el-select class="min" v-model="form.tagcode" placeholder="选择标签">
                        <el-option v-for="item in tagNameList" :label="item.name" :key="item.value" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="星球介绍" prop="stardesp">
                    <el-input type="textarea" v-model="form.stardesp" placeholder="输入星球介绍，不超过80字"  maxlength="80" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="公开星球">
                    <el-switch v-model="form.ispublic"></el-switch>
                    <span class="txt">公开后可以获得流量曝光</span>
                </el-form-item>
            </div>

            <div class="block">
                <p class="name">其它设置</p>

                <el-form-item label="加入审批">
                    <el-switch v-model="form.isjoinauth"></el-switch>
                    <span class="txt">开启后成员加入需要审批</span>
                </el-form-item>
                <el-form-item label="自动通知">
                    <el-switch v-model="form.isjoinautoreply"></el-switch>
                    <span class="txt">开启后，新加入的用户将会收到你设置的通知</span>
                    <el-input type="textarea" v-model="form.replycontent" placeholder="输入星球介绍，不超过80字"  maxlength="80" style="margin-top:10px" show-word-limit></el-input>
                    <p class="txt">{星主名称}、{星球名称}可自动替换，请谨慎修改</p>
                    <!--你好，我是{星主名称}，欢迎加入「{星球名称}」，希望大家多在星球沟通。-->
                </el-form-item>
            </div>

            <div class="block">
                <p class="name">权限设置</p>
                <el-form-item label="发表公告">
                    <el-radio-group v-model="form.releasenotespri">
                        <el-radio v-for="item in authorityList" :label="item.key">{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发表资料">
                    <el-radio-group v-model="form.releasefilepri">
                        <el-radio v-for="item in authorityList" :label="item.key">{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发表帖子">
                    <el-radio-group v-model="form.releasesubjectpri">
                        <el-radio v-for="item in authorityList" :label="item.key">{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="新成员限制">
                    <el-switch v-model="form.isnewmemberafterday"></el-switch>
                    <span class="txt">开启新成员一天后才可以发表帖子</span>
                </el-form-item>
                <el-form-item label="分享帖子">
                    <el-switch v-model="form.issharesubject"></el-switch>
                    <span class="txt">开启后允许成员分享帖子</span>
                </el-form-item>
                <el-form-item label="开放成员表">
                    <el-switch v-model="form.isshowmemberlist"></el-switch>
                    <span class="txt">开启后星球成员列表可以被查看</span>
                </el-form-item>
            </div>
            <div class="block">
                <p class="name">购买设置</p>
                <el-form-item label="售卖方式">
                    <div class="setup">

                        <el-form-item label="售卖设置" prop="feetype">
                            <el-radio-group v-model="form.feetype">
                                <el-radio v-for="item in feetypeList" :label="item.key" :disabled="true">{{item.label}}</el-radio>
                            </el-radio-group>

                            <template v-if="form.feetype == 3">
                                <el-form-item class="setup-item" label="加入价格" prop="joinfactmoney">
                                    <el-input v-model="form.joinfactmoney" porp="name" class="setup-input" placeholder="请输入商品价格"></el-input> <span class="txt">元</span>
                                </el-form-item>
                                <el-form-item class="setup-item" label="划线价格">
                                    <el-input v-model="form.joinmoney" class="setup-input" placeholder="请输入商品价格"></el-input> <span class="txt">元</span>
                                </el-form-item>
                                <el-form-item class="setup-item" label="有效期">
                                    <el-select v-model="form.memberexpiretime" class="min" placeholder="选择有效期">
                                        <el-option v-for="item in memberexpiretimelist" :label="item.label" :value='item.key' :ket="item.key" :disabled="true"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-form-item>
                    </div>

                </el-form-item>
            </div>

            <el-form-item>
                <!--<el-button>取消</el-button>-->
                <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="系统头像" :visible.sync="dialogVisible" width="516px">

            <div class="headerimg">

                <template v-for="(img,index) in headerImg">
                    <input :index="index" :id="'img_'+ index" name="headerimg" type="radio" style="display:none">
                    <label :for="'img_'+ index">
                        <img :src="imgUrl + img" alt="headerimg">
                    </label>
                </template>
                <div class="btn">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="headerimg()">确定</el-button>
                </div>

            </div>

        </el-dialog>
    </div>
</template>

<script>
    import Upload from 'base/upload/upload'
    import UploadFile from 'base/upload/uploadFile'
    import { getStarInfo,updateStarInfo } from 'api/communityApi'
    import {mapGetters, mapActions} from 'vuex'
    import {formatFileInfo} from '@/common/js/tools' // 引入 tools 库

    export default {
        name: "maintain",
        data() {
            return {
                innerid: this.$route.query.innerid,//星球innerid;
                updateImgStatus: false, //  图片修改状态
                dialogVisible: false,
                imgUrl: "http://img.capwhale.com/mp/bg/", // 服务器头像图片url
                headerImg: [
                    'starHeadImgs/1.png',
                    'starHeadImgs/2.png',
                    'starHeadImgs/3.png',
                    'starHeadImgs/4.png',
                    'starHeadImgs/5.png',
                    'starHeadImgs/6.png',
                    'starHeadImgs/7.png',
                    'starHeadImgs/8.png',
                    'starHeadImgs/9.png',
                    'starHeadImgs/10.png',
                    'starHeadImgs/11.png',
                    'starHeadImgs/12.png',
                    'starHeadImgs/13.png',
                    'starHeadImgs/14.png',
                    'starHeadImgs/15.png',
                    'starHeadImgs/16.png',
                    'starHeadImgs/17.png',
                    'starHeadImgs/18.png',
                    'starHeadImgs/19.png',
                    'starHeadImgs/20.png',
                    'starHeadImgs/21.png',
                    'starHeadImgs/22.png'
                ],  // 服务器系统头像地址
                authorityList:[{key:1,label:'所有人'},{key:2,label:'星主'},{key:3,label:'星主和管理员'}], // 权限数组 authority
                feetypeList: [{key:1,label:'完全免费'},{key:2,label:'分享解锁'},{key:3,label:'完全收费'}], //售卖方式设置
                memberexpiretimelist: [{key:1,label:'成员加入日期往后计算一年'},{key:0,label:'成员加入后一直有效'}],
                switchlist: ['ispublic','isjoinauth','isjoinautoreply','isnewmemberafterday','issharesubject','isshowmemberlist'], // 开关按钮
                starMgtForm:{
                    starname: '',
                    tagcode: '',
                    logodata: {
                        bucket: '',
                        fname: '',
                        fsize: '',
                        width: '',
                        height: '',
                        key: '',
                        mimetype: '',
                        objecttype: '',
                        furl: ''
                    },
                    ispublic: false,
                    stardesp: ''
                },
                tagNameList: [
                    {
                        name: '金融',
                        value: '01',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '科技',
                        value: '02',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '创业',
                        value: '03',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '资本',
                        value: '04',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '游戏',
                        value: '06',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '互联网',
                        value: '05',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '消费',
                        value: '07',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '教育',
                        value: '08',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '地产',
                        value: '09',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '医疗',
                        value: '10',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '健康',
                        value: '11',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '文娱',
                        value: '12',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '环保',
                        value: '13',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '智能制造',
                        value: '15',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: 'IT',
                        value: '14',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '服务业',
                        value: '16',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '新零售',
                        value: '17',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '新媒体',
                        value: '18',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '新材料',
                        value: '19',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '连锁',
                        value: '20',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: 'SaaS',
                        value: '21',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '区块链',
                        value: '22',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '人工智能',
                        value: '23',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '营销',
                        value: '24',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '商业管理',
                        value: '25',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '制造业',
                        value: '26',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    },
                    {
                        name: '其他',
                        value: '27',
                        checked: false,
                        color: 'rgb(242, 242, 242)'
                    }

                ],  // 星球标签 列表
                form: {
                    // 有效期
                    starname: '', //星球名称;
                    starlogourl: '', //星球头像;
                    tagcode: '', //标签code;
                    tagname: '', //标签名称;
                    stardesp: '', //星球描述;
                    ispublic:  '', //是否对外展示:0否1是 ;
                    isjoinauth: '', //是否入群审核:0否 1是;
                    isjoinautoreply: '', //是否加入自动通知:0 否 1 是;
                    replycontent: '', //自动通知内容;

                    releasenotespri: '', //发表公告:1 所有人 2 星主 3 星主和管理员;
                    releasefilepri: '', //发表资料:1 所有人 2 星主 3 星主和管理员;
                    releasesubjectpri: '', //发表帖子:1 所有人 2 星主 3 星主和管理员;
                    isnewmemberafterday: '', //新成员限制:0 否 1 是;
                    issharesubject: '', //分享帖子:0 否 1 是;
                    isshowmemberlist: '', //是否放开星球成员列表:0否 1是;
                    feetype: '', //星球费用类型：1完全免费 2分享解锁 3 完全收费;

                    joinmoney: '', //加入价格-划线;
                    joinfactmoney: '', //加入实际价格;
                    memberexpiretime: '', //成员有效期-1 有效期1年 0 一直有效;

                    // name: '',
                    // region: '',
                    // date1: '',
                    // date2: '',
                    // delivery: false,
                    // type: [],
                    // resource: '',
                    // desc: '',
                    // setup: []
                },
                imgRule: {
                    cls: 'icon_upload',
                    accept: 'image/png,image/jpeg',
                    size: 2,
                    width: '',
                    height: ''
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                rules: {
                    starname: [
                        { required: true, message: '请输入星球名称', trigger: 'blur' },
                        { min: 1, max: 10, message: '星球名称长度在 1 到 10 个字符', trigger: 'blur' }
                    ],
                    starlogourl: [
                        { required: true, message: '请选择星球封面', trigger: 'blur' },
                    ],
                    tagcode: [
                        { required: true, message: '请选择星球标签', trigger: 'blur' },
                    ],
                    stardesp: [
                        { required: true, message: '请输入星球介绍', trigger: 'blur' },
                        { min: 1, max: 80, message: '星球介绍长度在 1 到 80 个字符', trigger: 'blur' }
                    ],
                    joinfactmoney: [
                        { required: true, message: '请输入加入价格', trigger: 'blur' },
                    ],
                    feetype: [
                        { required: true, message: '请选择售卖方式', trigger: 'blur' },
                    ]
                }
            }
        },
        methods: {
            onSubmit() {
                var dataapi = JSON.parse(JSON.stringify(this.form));
                var $this = this


                    console.log("joinmoney",dataapi.joinmoney)
                    console.log("joinfactmoney",dataapi.joinfactmoney)
                // 加入价格 > 划线价格   ||  加入价格 === 划线价格
                if(dataapi.feetype == 3 && (dataapi.joinmoney != 0 || dataapi.joinmoney != 0.00)) {
                     console.log(dataapi.joinmoney == 0)
                        if (dataapi.joinfactmoney > dataapi.joinmoney || dataapi.joinfactmoney == dataapi.joinmoney) {
                            this.$message.info('划线价格不能小于 或 等于 加入价格')
                            return  
                        }               
                }
                
                

                // 循环提交参数
                for (var item in dataapi) {
                    for (var switchs in $this.switchlist) {
                        if (item == $this.switchlist[switchs]) {

                            if (dataapi[item] == true) {
                                dataapi[item] = 1
                            } else {
                                dataapi[item] = 0
                            }
                            // continue
                        }
                    }
                    if (item === 'starlogourl') {
                        // 当头像图片发生变更时
                        if( $this.updateImgStatus === true ) {
                            var logoimg = JSON.parse(JSON.stringify($this.starMgtForm))
                            logoimg.logodata.type = 'add'

                            // logoimg.logodata = formatFileInfo(logoimg.logodata)
                            // console.log('提交',formatFileInfo(logoimg))
                            //
                            // console.log(logoimg);

                            dataapi['logodata'] = formatFileInfo(logoimg.logodata)
                        } else {
                            dataapi['logodata'] = ''
                        }
                    }
                }
                for (let item in $this.tagNameList) {
                    if ($this.tagNameList[item].value === dataapi.tagcode) {
                        dataapi.tagname = $this.tagNameList[item].name
                    }
                }

                dataapi.innerid = this.innerid

                this.setLoading(true)
                updateStarInfo({
                    data: dataapi,
                    success:data => {
                        this.setLoading(false)

                        if (data.code == "000") {
                            this.$message.success('保存成功')
                        }
                    },
                    error:data => {
                        this.setLoading(false)

                        this.$message.error(data.msg)
                    }
                })

            },
            // 设置图片信息（本地）
            setCoverfile(img) {
                // 发生头像图片变更操作
                this.updateImgStatus = true
                $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
                // console.log(img)
                this.starMgtForm.logodata = img
            },
            headerimg() {

                // 取得选择图片的下标
                let index = $("input[name=headerimg]:checked").attr('index')

                if (index) {

                    let imgurl = this.headerImg[index];
                    this.starMgtForm.logodata.bucket = this.starMgtForm.logodata.fname = this.starMgtForm.logodata.fsize
                        = this.starMgtForm.logodata.width = this.starMgtForm.logodata.height = this.starMgtForm.logodata.key
                        = this.starMgtForm.logodata.mimetype = this.starMgtForm.logodata.objecttype = this.starMgtForm.logodata.keyid
                        = this.starMgtForm.logodata.vsource = ''

                    this.starMgtForm.logodata.furl = this.imgUrl + imgurl
                    this.$refs.coverfile.setImage( this.starMgtForm.logodata.furl)
                    this.dialogVisible = false

                    // 发生头像图片变更操作
                    this.updateImgStatus = true

                } else {
                    this.$message.error('请选择头像')
                }
            },
            ...mapActions(['setLoading'])

        },
        mounted() {
            this.setLoading(true)
            getStarInfo({
                data: {innerid: this.innerid},
                success: data => {
                    this.setLoading(false)
                    // console.log(data)

                    var $this = this,
                        datalist = data.data;

                    this.$nextTick(function () {
                        for (var item in datalist) {
                            for (var switchs in $this.switchlist) {
                                if (item == $this.switchlist[switchs]) {

                                    if (datalist[item] == 1) {
                                        datalist[item] = true
                                    } else {
                                        datalist[item] = false
                                    }
                                    continue
                                }
                            }
                        }
                        $this.form = data.data

                        // 设置图片
                        $this.$refs.coverfile.setImage($this.form.starlogourl)
                        $this.starMgtForm.logodata.furl = $this.form.starlogourl

                        // $this.imageUrl = $this.starMgtForm.logodata = $this.form.starlogourl
                    })
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        components: {
            Upload,
            UploadFile
        },
        computed: {
            ...mapGetters(['loading'])
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .maintainIndex {
        .el-input__icon {
            line-height: normal;
        }
        .el-textarea__inner {
            height: 109px;
        }
        .block {
            margin-bottom: 30px;
            .el-form-item {
                max-width: 805px;
                .el-form-item__label {
                    width: 100px !important;
                    text-align: left;
                    padding-left: 10px;
                }
                .el-form-item__content {
                    margin-left: 100px !important;
                }
            }
            .name {
                margin-bottom: 20px;
                padding-left: 8px;
                font-size: 16px;
                font-weight: bold;
                border-left: solid 2px #00a0e9;
            }
            .min {
                width: 260px;
            }
            .avatar-uploader {
                width: 318px;
                height: 178px;
            }
            .setup {
                padding: 15px 23px;
                width: 805px;
                /*height: 187px;*/
                background: #F5F7FA;

                .setup-input {
                    width: 229px;
                }
                .txt {
                    margin-left: 10px;
                }
                .setup-item {
                    margin-left: 0 !important;
                }
            }
            .txt {
                display: inline-block;
                font-size: 14px;
                margin-left: 20px;
                line-height: 32px;
                color: #909399;
                -webkit-transform: translateY(2px);
                -moz-transform: translateY(2px);
                -ms-transform: translateY(2px);
                -o-transform: translateY(2px);
                transform: translateY(2px);
            }
        }
        .position,
        .upload {
            float: left;
        }
        .position {
            margin-top: 40px;
            margin-left: 10px;
        }
        .headerimg {
            margin-right: -10px;
            label {
                position: relative;
                display: inline-block;
                cursor: pointer;
                margin-right: 10px;
                margin-bottom: 10px;
                width:110px;
                height:65px;
                box-sizing: border-box;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            input[type=radio]:checked + label {
                border: solid 1px #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                background-size: 23px;
            }
            .btn {
                margin-top: 20px;
                text-align: center;
            }
        }
    }
</style>
